import { create } from 'zustand';
import type { PolicyStore } from '../../../../widgets/Policy/model/types/PolicyStore';

import { PolicyRegistrationType } from '@/features/PolicyRegistration/model/schema/zodSchema';
import { CoastCalculationType } from '@/features/CoastCalculation/model/schema';

export const usePolicyStore = create<PolicyStore>((set) => ({
    id: undefined,
    calculated: false,
    smsCode: '',
    smsError: '',
    price: '',
    ids: {
        pasportId: null,
        userId: null,
        creditInfoId: null,
        actualAddressId: null,
        postAddressId: null,
    },
    formData: {} as CoastCalculationType,
    secondFormData: {} as PolicyRegistrationType,
    policyProcess: 'CoastCalculation',
    isSuccess: false,
    error: '',
    formStateChanged: false,
    isSendSmsError: false,

    setForm: (data: CoastCalculationType) =>
        set(() => ({
            formData: { ...data },
        })),
    setSecondForm: (data: Partial<PolicyRegistrationType>) =>
        set(() => ({
            secondFormData: { ...data },
        })),
    setPolicyProcess: (value) =>
        set(() => ({
            policyProcess: value,
        })),
    setCalculated: (value) =>
        set(() => ({
            calculated: value,
        })),
    setPrice: (value) =>
        set(() => ({
            price: value,
        })),
    setId: (id) =>
        set(() => ({
            id,
        })),
    setIsSuccess: (isSuccess) =>
        set(() => ({
            isSuccess,
        })),
    setSmsCode: (smsCode) =>
        set(() => ({
            smsCode,
        })),

    setIds: (ids) =>
        set(() => ({
            ids,
        })),
    setError: (error) => {
        set(() => ({
            error,
        }));
    },
    setSmsError: (smsError) => {
        set(() => ({
            smsError,
        }));
    },
    setFormStateChanged: (formStateChanged) => {
        set(() => ({
            formStateChanged,
        }));
    },
    setIsSendSmsError: (isSendSmsError) => {
        set(() => ({
            isSendSmsError,
        }));
    },
    cleanUp: () => {
        set(() => ({
            id: undefined,
            calculated: false,
            smsCode: '',
            smsError: '',
            price: '',
            ids: {
                pasportId: null,
                userId: null,
                creditInfoId: null,
                actualAddressId: null,
                postAddressId: null,
            },
            formData: {} as CoastCalculationType,
            secondFormData: {} as PolicyRegistrationType,
            policyProcess: 'CoastCalculation',
            isSuccess: false,
            error: '',
        }));
    },
}));
